module.exports = __webpack_public_path__ + "static/media/spinner.1cfda328.svg";